<template>
  <div class="commands-section">
    <div class="options-panel_head">
      <div class="s-title text-green">
        Настройка команд быстрого доступа
      </div>
      <p class="text-base">
        <!--Переместите нужные команды в панель быстрого доступа,  размер кнопки можно изменить.
        Для удаления на свободное пространтсво.-->
      </p>
    </div>
    <div class="style-hr__solid">
    </div>
    <div class="list-commands">
      <div class="list-commands_col">
        <div class="list-commands_title">
          {{commands[0].name}}
        </div>
        <draggable class="list-commands_actual"
                   :list="commands[0].list"
                   group="people">
          <div class="commands-item"
               v-for="element in commands[0].list"
               v-on:click="sendCommand(index, 0)">
            <div class="commands-item_img">
              <img v-bind:src="pathImg( element.icon )">
            </div>
            <div class="commands-item_name">
              {{element.title}}
            </div>
          </div>
        </draggable>
        <div class="text-right">
          <button class="btn btn-success" v-on:click="saveList()">Сохранить</button>
        </div>
      </div>
      <div class="list-commands_sep">
      </div>
      <div class="list-commands_col">
          <div class="list-commands_title">
            {{commands[1].name}}
            {{listCar[currentIndex].device.model}}
          </div>
          <draggable class="list-group"
                     :list="commands[1].list"
                     group="people">
            <div class="commands-item"
                 v-for="(element, index) in commands[1].list"
                 v-show="element.name !== 'get_location' ? true : (listCar[currentIndex].device.model > 15)"
                 v-on:click="sendCommand(index, 1)">
              <div class="commands-item_img">
                <img :src="pathImg( element.icon )">
              </div>
              <div class="commands-item_name">
                {{element.title}}
              </div>
            </div>
          </draggable>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import { HTTP } from '../../main'

  export default {
    data(){
      return{
      }
    },
    methods : {
      sendCommand : function ( index, listIndex ) {
        HTTP.post('cars/' + this.currentId + '/command/', {
          car_id : this.currentId,
          cmd: this.commands[listIndex].list[index].name
        }).then( () => {

        }).catch( (error) => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      saveList : function () {
        document.cookie = "commandsList=" + JSON.stringify(this.commands);
        this.$store.dispatch( 'addAlert', { text : 'Настройки сохранены', type : 'success' });

        this.$store.dispatch('changeCommandList');
      },
      pathImg : function ( icon ) {
        if( this.listCar[this.currentIndex].device.type === 1 ){
          return require('@/assets/img/car_button/' + icon + '.svg') ;
        }else{
          return require('@/assets/img/mobicar/commands/' + icon + '.svg');
        }
      }
    },
    computed : {
      currentIndex : function () {
        return this.$store.state.cars.current.index
      },
      currentId : function () {
        return this.$store.state.cars.current.id
      },
      listCar(){
        return this.$store.state.cars.list;
      },
      commands : function () {
        if( this.listCar[this.currentIndex].device.type === 1 ){
          return this.$store.state.commandsUni
        }else{
          return this.$store.state.commandsMobicar
        }
      },
    },
    components : {
      draggable,
    }
  }
</script>
